.root {
  --card-padding: var(--mantine-spacing-md);

  position: relative;
  overflow: hidden;
  display: flex;
  padding: var(--card-padding);
  color: var(--mantine-color-text);

  &:where([data-orientation='horizontal']) {
    flex-direction: row;
  }

  &:where([data-orientation='vertical']) {
    flex-direction: column;
  }

  @mixin where-light {
    background-color: var(--mantine-color-white);
  }

  @mixin where-dark {
    background-color: var(--mantine-color-dark-6);
  }
}

.section {
  display: block;
  margin-inline: calc(var(--card-padding) * -1);

  @mixin where-light {
    --border-color: var(--mantine-color-gray-3);
  }

  @mixin where-dark {
    --border-color: var(--mantine-color-dark-4);
  }

  &:where([data-orientation='vertical']) {
    &:first-child {
      margin-top: calc(var(--card-padding) * -1);
      border-top: none !important;
    }

    &:last-child {
      margin-bottom: calc(var(--card-padding) * -1);
      border-bottom: none !important;
    }

    &[data-inherit-padding] {
      padding-inline: var(--card-padding);
    }

    &[data-with-border] {
      border-top: 1px solid var(--border-color);
      border-bottom: 1px solid var(--border-color);
    }

    & + & {
      border-top: none !important;
    }
  }

  &:where([data-orientation='horizontal']) {
    margin-block: calc(var(--card-padding) * -1);
    margin-inline: 0;

    &:first-child {
      margin-inline-start: calc(var(--card-padding) * -1);
      border-inline-start: none !important;
    }

    &:last-child {
      margin-inline-end: calc(var(--card-padding) * -1);
      border-inline-end: none !important;
    }

    &[data-inherit-padding] {
      padding-block: var(--card-padding);
    }

    &[data-with-border] {
      border-inline-start: 1px solid var(--border-color);
      border-inline-end: 1px solid var(--border-color);
    }

    & + & {
      border-inline-start: none !important;
    }
  }
}
